export default __webpack_public_path__ + "static/gilroy-regular-0562650729e883c4f158c2207c6ba5dd.woff";